import dayjs from 'dayjs';

const recurrenceRateToDayJsUnit: Record<'weekly' | 'bi-weekly' | 'monthly', 'month' | 'week'> = {
  weekly: 'week',
  'bi-weekly': 'week',
  monthly: 'month',
};
export const getRecurrenceDatesSameDay = ({
  recurrenceRate,
  startDate,
  amount,
}: {
  recurrenceRate: 'weekly' | 'bi-weekly' | 'monthly';
  startDate: Date;
  amount: number;
}) => {
  const dates: Date[] = [];

  const step = recurrenceRate === 'bi-weekly' ? 2 : 1;
  const unit = recurrenceRateToDayJsUnit[recurrenceRate];

  for (let i = 0; i < amount; i++) {
    const nextDate = dayjs(startDate)
      .add(step * i, unit)
      .toDate();

    dates.push(nextDate);
  }

  return dates;
};
